module.exports = __webpack_public_path__ + "static/media/outdoor.e95da9b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/outdoor.png
// module id = 797
// module chunks = 0